import { createSlice } from '@reduxjs/toolkit'
import { GetOrdersResponseType, OrdersType } from '../../actions/types'
import {
  createOrder,
  getCurrentOrder,
  getOrders,
  removeProductFromOrder,
} from '../../actions/ordersAction'

export interface IOrders {
  orders: GetOrdersResponseType
  currentPlaceOrders: OrdersType
  error: string
  isLoading: boolean
}

const initialState: IOrders = {
  orders: {
    orders: [],
    totalCount: 0,
  },
  currentPlaceOrders: {
    id: 0,
    orderId: 0,
    productIds: [],
    orderDetails: [],
    totalPrice: 0,
    price: 0,
  },
  isLoading: false,
  error: '',
}

export const ordersSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOrders.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getOrders.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.orders = action.payload
    })
    builder.addCase(getOrders.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload as string
    })
    builder.addCase(getCurrentOrder.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getCurrentOrder.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.currentPlaceOrders = action.payload
    })
    builder.addCase(getCurrentOrder.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload as string
    })
    builder.addCase(createOrder.pending, (state) => {
      state.error = ''
    })
    builder.addCase(createOrder.fulfilled, (state) => {
      state.error = ''
    })

    builder
      .addCase(createOrder.rejected, (state, action) => {
        state.error = action.payload as string
      })
      .addCase(removeProductFromOrder.pending, (state) => {
        state.isLoading = true
      })
      .addCase(removeProductFromOrder.fulfilled, (state, action) => {
        state.isLoading = false
        state.error = ''

        const updatedOrderDetails = state.currentPlaceOrders?.orderDetails.filter(
          (item) => item.productId !== action.payload.productId,
        )
        state.currentPlaceOrders.orderDetails = updatedOrderDetails

        state.currentPlaceOrders.totalPrice = action.payload.totalPrice
      })
      .addCase(removeProductFromOrder.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
  },
})

export const orderReducer = ordersSlice.reducer
